import { UIActionDropdown, UITooltip } from '@gohighlevel/ghl-ui'
import { h } from 'vue'

export const CalendarActionTooltip = ({
  parentId,
  id,
  icon,
  action,
  showTooltip,
  tooltipText,
  data,
  isDropdown = false,
  dropDownActionChange,
  tableActionDropdownOptions,
  customClass,
}: {
  parentId: string
  id: string
  icon?: any
  action?: string
  showTooltip?: boolean
  tooltipText: string
  data: any
  isDropdown?: boolean
  dropDownActionChange: (action: string, data: any) => void
  tableActionDropdownOptions?: any[]
  customClass?: any
}) => {
  return h('div', { id: `${parentId}` }, [
    h(
      UITooltip,
      { placement: 'top', trigger: showTooltip ? 'hover' : 'manual' },
      {
        trigger: () =>
          isDropdown
            ? h(
              'div',
              h(
                UIActionDropdown,
                {
                  options: tableActionDropdownOptions,
                  onSelect: val => dropDownActionChange(val, data),
                  id,
                  nodeProps: opt => {
                    return { 'aria-label': opt.label }
                  },
                },
                {}
              )
            )
            : h(
              'div',
              {
                id,
                class: customClass
                  ? 'cursor-pointer w-[38px] ' + customClass
                  : 'cursor-pointer w-[38px]',
                onClick: () => dropDownActionChange(action || '', data),
              },
              h(icon, { class: 'w-[20px] h-[20px]  cursor-pointer' })
            ),
        default: () =>
          h('div', { style: { fontFamily: 'Inter !important' } }, tooltipText),
      }
    ),
  ])
}
